import { useState, useCallback, useEffect } from 'react';
import groupServices from 'services/group.services';

export default function useGetGroupInstantPayoutType() {
  const [loading, setLoading] = useState(false);
  const [listGroupInstantPayoutTypes, setListGroupInstantPayoutTypes] = useState([]);

  const getGroupInstantPayoutTypes = useCallback(async () => {
    try {
      setLoading(true);
      const data = await groupServices.listGroupInstantPayoutType();
      setListGroupInstantPayoutTypes(data.items);
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getGroupInstantPayoutTypes();
  }, []);

  return {
    loading,
    listGroupInstantPayoutTypes,
    getGroupInstantPayoutTypes
  };
}
